import { render, staticRenderFns } from "./SubZonas.vue?vue&type=template&id=30425110&scoped=true"
import script from "./SubZonas.vue?vue&type=script&lang=js"
export * from "./SubZonas.vue?vue&type=script&lang=js"
import style0 from "./SubZonas.vue?vue&type=style&index=0&id=30425110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30425110",
  null
  
)

export default component.exports